import { useCallback, useEffect, useRef } from "react";
import { useLoginSuccessCallback } from "./useLoginSuccessCallback";
import { GOOGLE_CLIENT_ID } from "@/config/index";
export function useGoogleLogin(param) {
  let {
    flow = "implicit",
    scope = "",
    onSuccess,
    onError,
    onNonOAuthError,
    overrideScope,
    state,
    client_id = GOOGLE_CLIENT_ID,
    ...props
  } = param;
  const clientRef = useRef();
  const onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  const onNonOAuthErrorRef = useRef(onNonOAuthError);
  onNonOAuthErrorRef.current = onNonOAuthError;
  const [successCallback] = useLoginSuccessCallback();
  useEffect(() => {
    var _window_google_accounts, _window_google, _window;
    if (!((_window = window) === null || _window === void 0 ? void 0 : (_window_google = _window.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : _window_google_accounts.oauth2)) {
      console.error("Google OAuth2 library not found.");
      return;
    }
    const clientMethod = flow === "implicit" ? "initTokenClient" : "initCodeClient";
    const client = window.google.accounts.oauth2[clientMethod]({
      client_id,
      redirect_uri: "postmessage",
      scope: overrideScope ? scope : "openid profile email ".concat(scope),
      callback: response => {
        var _onErrorRef_current;
        if (response.error) return (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, response);
        if (onSuccessRef.current) {
          var _onSuccessRef_current;
          (_onSuccessRef_current = onSuccessRef.current) === null || _onSuccessRef_current === void 0 ? void 0 : _onSuccessRef_current.call(onSuccessRef, response);
        } else {
          successCallback(response);
        }
      },
      error_callback: nonOAuthError => {
        var _onNonOAuthErrorRef_current;
        (_onNonOAuthErrorRef_current = onNonOAuthErrorRef.current) === null || _onNonOAuthErrorRef_current === void 0 ? void 0 : _onNonOAuthErrorRef_current.call(onNonOAuthErrorRef, nonOAuthError);
      },
      state,
      ...props
    });
    clientRef.current = client;
  }, [flow, scope, state]);
  const loginImplicitFlow = useCallback(overrideConfig => {
    var _clientRef_current;
    return (_clientRef_current = clientRef.current) === null || _clientRef_current === void 0 ? void 0 : _clientRef_current.requestAccessToken(overrideConfig);
  }, []);
  const loginAuthCodeFlow = useCallback(() => {
    var _clientRef_current;
    return (_clientRef_current = clientRef.current) === null || _clientRef_current === void 0 ? void 0 : _clientRef_current.requestCode();
  }, []);
  return flow === "implicit" ? loginImplicitFlow : loginAuthCodeFlow;
}